<template>
  <div class="signup__step signup__step--03 company-form">
    <div class="stepForm">
      <div class="content">
        <!-- Campos de endereço -->
        <template>
          <div class="content__header">
            <h2 class="content__title">Informações de endereço</h2>
            <p class="content__description">
              Estes dados vão aparecer como <strong>remetente</strong> nas
              etiquetas e vão ser usados como seu endereço fiscal. <br />
              Não se preocupe: Você vai poder alterar essas informações ou
              adicionar novos endereços depois.
            </p>
          </div>
          <div class="">
            <div class="formLineBox formLineBox--0102">
              <fieldset
                class="formLine"
                :class="{
                  active: iptCepEmpresa,
                  error: $v.iptCepEmpresa.$error,
                  focus: focus.iptCepEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptCepEmpresa">CEP *</label>
                  <input
                    type="tel"
                    name="iptCepEmpresa"
                    id="iptCepEmpresa"
                    v-model="iptCepEmpresa"
                    v-mask="'99999-999'"
                    @focus="iptFocus('iptCepEmpresa', $event)"
                    @blur="iptBlur('iptCepEmpresa', $event)"
                    @input="[enableSelect('iptCidadeEmpresa'), enableSelect('slEstadoEmpresa')]"
                    data-cy="company-input-cep"
                  />
                  <p class="errorText">{{ errors.iptCepEmpresa }}</p>
                </div>
              </fieldset>

              <fieldset
                class="formLine"
                :class="{
                  active: iptEnderecoEmpresa,
                  error: $v.iptEnderecoEmpresa.$error,
                  focus: focus.iptEnderecoEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptEnderecoEmpresa">Endereço *</label>
                  <input
                    type="text"
                    name="iptEnderecoEmpresa"
                    id="iptEnderecoEmpresa"
                    v-model="iptEnderecoEmpresa"
                    @focus="iptFocus('iptEnderecoEmpresa', $event)"
                    @blur="iptBlur('iptEnderecoEmpresa', $event)"
                    data-cy="company-input-address"
                  />
                  <p class="errorText">{{ errors.iptEnderecoEmpresa }}</p>
                </div>
              </fieldset>
            </div>
            <div class="formLineBox formLineBox--03-m0201-xs01">
              <fieldset
                class="formLine"
                :class="{
                  active: iptNumeroEmpresa,
                  error: $v.iptNumeroEmpresa.$error,
                  focus: focus.iptNumeroEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptNumeroEmpresa">Número *</label>
                  <input
                    type="text"
                    name="iptNumeroEmpresa"
                    id="iptNumeroEmpresa"
                    v-model="iptNumeroEmpresa"
                    @focus="iptFocus('iptNumeroEmpresa', $event)"
                    @blur="iptBlur('iptNumeroEmpresa', $event)"
                    data-cy="company-input-number"
                  />
                  <p class="errorText">{{ errors.iptNumeroEmpresa }}</p>
                </div>
              </fieldset>

              <fieldset
                class="formLine"
                :class="{
                  active: iptComplementoEmpresa,
                  error: $v.iptComplementoEmpresa.$error,
                  focus: focus.iptComplementoEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptComplementoEmpresa">Complemento</label>
                  <input
                    type="text"
                    name="iptComplementoEmpresa"
                    id="iptComplementoEmpresa"
                    v-model="iptComplementoEmpresa"
                    @focus="iptFocus('iptComplementoEmpresa', $event)"
                    @blur="iptBlur('iptComplementoEmpresa', $event)"
                    data-cy="company-input-complement"
                  />
                  <p class="errorText">{{ errors.iptComplementoEmpresa }}</p>
                </div>
              </fieldset>

              <fieldset
                class="formLine"
                :class="{
                  active: iptBairroEmpresa,
                  error: $v.iptBairroEmpresa.$error,
                  focus: focus.iptBairroEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptBairroEmpresa">Bairro</label>
                  <input
                    type="text"
                    name="iptBairroEmpresa"
                    id="iptBairroEmpresa"
                    v-model="iptBairroEmpresa"
                    @focus="iptFocus('iptBairroEmpresa', $event)"
                    @blur="iptBlur('iptBairroEmpresa', $event)"
                    data-cy="company-input-district"
                  />
                  <p class="errorText">{{ errors.iptBairroEmpresa }}</p>
                </div>
              </fieldset>
            </div>

            <div class="formLineBox formLineBox--02xs01">
              <fieldset
                class="formLine"
                :class="{
                  active: slEstadoEmpresa,
                  error: $v.slEstadoEmpresa.$error,
                  focus: focus.slEstadoEmpresa,
                }"
              >
                <div class="inputBox">
                  <model-select
                    name="slEstadoEmpresa"
                    id="slEstadoEmpresa"
                    v-model="slEstadoEmpresa"
                    :options="statesData"
                    :isDisabled="disabled.slEstadoEmpresa"
                    @focus="iptFocus('slEstadoEmpresa', 'address', $event)"
                    @blur="iptBlur('slEstadoEmpresa', 'address', $event)"
                    @input="[$v.slEstadoEmpresa.$touch, getCitiesFromState($event), iptCidadeEmpresa = '']"
                    data-cy="company-input-state"
                  >
                  </model-select>
                  <label for="slEstadoEmpresa">Estado *</label>

                  <p class="errorText">{{ errors.slEstadoEmpresa }}</p>
                </div>
              </fieldset>
              <fieldset
                class="formLine"
                :class="{
                  active: iptCidadeEmpresa,
                  error: $v.iptCidadeEmpresa.$error,
                  focus: focus.iptCidadeEmpresa,
                }"
              >
                <div class="inputBox">
                  <label for="iptCidadeEmpresa">Cidade *</label>
                  <model-select
                    type="text"
                    name="iptCidadeEmpresa"
                    id="iptCidadeEmpresa"
                    v-model="iptCidadeEmpresa"
                    :options="cities"
                    :isDisabled="disabled.iptCidadeEmpresa"
                    @focus="iptFocus('iptCidadeEmpresa', $event)"
                    @blur="iptBlur('iptCidadeEmpresa', $event)"
                    data-cy="company-input-city"
                  ></model-select>
                  <p class="errorText">{{ errors.iptCidadeEmpresa }}</p>
                </div>
              </fieldset>

            </div>
          </div>

          <div class="button__container">
            <button
              name="Avançar formulário"
              type="submit"
              class="button button--primary"
              @click="submit"
              data-cy="company-button-confirm"
            >
              avançar
            </button>
          </div>
        </template>
      </div>
    </div>

    <!-- error modal -->
    <transition name="fade">
      <modal-base
        v-if="$parent.showModal"
        title='Atenção!'
        class="lead-form__error-modal"
      >
        <template v-slot:close-icon>
          <svg @click.prevent='$parent.showModal = false' class='modal__close-icon'>
            <use xlink:href='/images/svg-symbols.svg#close' />
          </svg>
        </template>
        <template v-slot:content>
          <p style="text-align: center !important">
            Ops! Ocorreu um erro no seu cadastro. <br />
            {{
              modalErrorMessage
                ? "modalErrorMessage"
                : "Por favor, verifique suas informações."
            }}
          </p>
        </template>
        <template v-slot:footer>
          <button class="button button--primary" @click.prevent="$parent.showModal = false">
            Tentar novamente
          </button>
        </template>
      </modal-base>
    </transition>
  </div>
</template>

<script>
import {
  minLength,
  maxLength,
  alphaNum,
} from "vuelidate/lib/validators";

import { ModelSelect } from "vue-search-select";

import BRStates from "commons/js/BRStates";

import AwesomeMask from "awesome-mask";

import ModalBase from "commons/js/components/atoms/ModalBase.vue";

import {scrollToTop} from 'commons/js/utils/scroll.js';
import PostalCodeVerify from 'commons/js/PostalCodeVerify';

export default {
  components: {
    ModelSelect,
    ModalBase
  },

  data() {
    return {
      cities: [],
      disabled: {
        slEstadoEmpresa: false,
        iptCidadeEmpresa: false
      },

      iptCepEmpresa: "",
      iptEnderecoEmpresa: "",
      iptNumeroEmpresa: "",
      iptComplementoEmpresa: "",
      iptBairroEmpresa: "",
      iptCidadeEmpresa: "",
      slEstadoEmpresa: "",

      showEmpresaForm: true,
      showFirstStep: true,

      errorMessages: {
        required: "Campo obrigatório! Não esqueça de preenchê-lo.",
        requiredIf: "Campo obrigatório! Não esqueça de preenchê-lo.",
        minLength: "Dado inválido! Verifique sua resposta.",
        maxLength: "Dado inválido! Verifique sua resposta.",
        alpha: "Dado inválido! Verifique sua resposta.",
        numeric: "Dado inválido! Verifique sua resposta.",
        isUnique: "Este __field__ já está cadastrado ou é inválido. Gostaria de fazer login?",
        alphaNum: "O campo aceita apaneas letras e números.",
      },

      errors: {
        iptCepEmpresa: "",
        iptEnderecoEmpresa: "",
        iptNumeroEmpresa: "",
        iptComplementoEmpresa: "",
        iptBairroEmpresa: "",
        iptCidadeEmpresa: "",
        slEstadoEmpresa: "",
      },

      focus: {
        iptCepEmpresa: false,
        iptEnderecoEmpresa: false,
        iptNumeroEmpresa: false,
        iptComplementoEmpresa: false,
        iptBairroEmpresa: false,
        iptCidadeEmpresa: false,
        slEstadoEmpresa: false,
      },

      states: BRStates,
      modalErrorMessage: "",
    };
  },

  directives: {
    mask: AwesomeMask,
  },

  mounted() {
    scrollToTop();
    setTimeout(this.$v.$reset, 0);
  },

  computed: {
    statesData: function () {
      return this.states
        .map((state) => {
          return {
            value: state.state_abbr,
            text: state.state,
          };
        })
        .sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
    }
  },

  methods: {
    iptFocus(ipt) {
      this.focus[ipt] = true;
    },
    iptBlur(ipt) {
      this.focus[ipt] = false;
      this.$v[ipt].$touch();
      this.updateErrorMessage(ipt);
      if (ipt === "iptCepEmpresa" && this.iptCepEmpresa) {
        this.completeAddress();
      }
    },

    async completeAddress() {
      this.$parent.loading = true;

      try {
        const data = await PostalCodeVerify(this.iptCepEmpresa);

        this.iptBairroEmpresa = '';

        this.cities = [];
        this.iptCidadeEmpresa = '';

        this.slEstadoEmpresa = '';
        this.iptEnderecoEmpresa = '';

        if(!data) {
          return;
        }

        const {address, district, city, state_abbr} = data;

        if (address) {
          this.iptEnderecoEmpresa = address;
          this.$el.querySelector('#iptNumeroEmpresa').focus();
        }
        if (district) {
          this.iptBairroEmpresa = district;
        }
        if (state_abbr) {
          this.slEstadoEmpresa = state_abbr;
          await this.getCitiesFromState(state_abbr);

          this.disableSelect('slEstadoEmpresa');
        }
        if (city) {
          if (this.cities) {
            const values = this.cities.map((city) => {
              return city.value.toLowerCase();
            })

            const index = values.indexOf(city.toLowerCase());

            this.iptCidadeEmpresa = this.cities[index].value;
            this.disableSelect('iptCidadeEmpresa');
          } else {
            this.iptCidadeEmpresa = city;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$parent.loading = false;
      }
    },

    async getCitiesFromState(stateAbbr) {
      const {data} = await axios.get(`/api/v2/locations/state/${stateAbbr}/cities`);

      if(data) {
        this.cities = data.map(({city}) => {
          return {
            value: city,
            text: `${city} `
          };
        });
      }
    },

    disableSelect(id) {
      this.disabled[id] = true;
      this.$el.querySelector(`#${id}`).disabled = true;
    },

    enableSelect(id) {
      this.disabled[id] = false;
      this.$el.querySelector(`#${id}`).disabled = false;
    },

    updateErrorMessage(key) {
      let errorTypes = Object.keys(this.errorMessages);
      for (let i = 0; i < errorTypes.length; i++) {
        let errorType = errorTypes[i];
        if (
          this.$v[key].hasOwnProperty(errorType) &&
          !this.$v[key][errorType]
        ) {
          this.errors[key] = "";
          if (this.errorMessages.hasOwnProperty(errorType)) {
            this.errors[key] = String(this.errorMessages[errorType]).replace(
              /__field__/,
              String(key)
                .replace(/^ipt/, "")
                .replace(/Change$/, "")
            );
          }
          break;
        }
      }
    },
    submit() {
      scrollToTop();
      if (this.$v.$invalid) {
        this.$v.$touch();
        let errorTypes = Object.keys(this.errorMessages);
        Object.keys(this.$v.$params).forEach((e) => {
          for (let i = 0; i < errorTypes.length; i++) {
            let errorType = errorTypes[i];
            if (
              this.$v[e].hasOwnProperty(errorType) &&
              !this.$v[e][errorType]
            ) {
              this.errors[e] = "";
              if (this.errorMessages.hasOwnProperty(errorType)) {
                this.errors[e] = String(this.errorMessages[errorType]);
              }
              break;
            }
          }
        });
        return;
      }
      this.registerCompany();
    },
    registerCompany() {
      const DEFAULT_LABEL = 'Meu endereço';

      let address = {
        label: DEFAULT_LABEL,
        postal_code: String(this.iptCepEmpresa).replace(/\D/g, ""),
        address: String(this.iptEnderecoEmpresa).trim(),
        number: String(this.iptNumeroEmpresa).trim(),
        complement: String(this.iptComplementoEmpresa).trim(),
        district: String(this.iptBairroEmpresa).trim(),
        city: String(this.iptCidadeEmpresa).trim(),
        state: String(this.slEstadoEmpresa).trim(),
        country: "BR",
      };

      this.$parent.loading = true;

      Object.keys(address).forEach((key) => {
        if (!address[key]) delete address[key];
      });

      axios
        .post("/api/v2/me/addresses", address)
        .then((response) => {
          if (response.data && response.data.id) {
            this.$parent.next();
            scrollToTop();
          }
        })
        .catch(() => {
          this.setErrorModalMessage(error.response.status);
          this.$parent.showModal = true;
        })
        .finally(() => {
          this.$parent.loading = false;
        });
    },
  },

  setErrorModalMessage(errorStatus) {
    switch (errorStatus) {
      case 401:
        this.modalErrorMessage = 'Parece que você não está logado no sistema.';
        break;

      case 422:
        this.modalErrorMessage = 'Existem erros no preenchimento dos campos.';
        break;

      default:
        break;
    }
  },

  validations: {
    iptCepEmpresa: {
      requiredIf(value, self) {
        if (!self.showEmpresaForm) return true;
        return !!value;
      },
      minLength: minLength(5),
      maxLength: maxLength(10),
    },
    iptEnderecoEmpresa: {
      requiredIf(value, self) {
        if (!self.showEmpresaForm) return true;
        return !!value;
      },
      maxLength: maxLength(128),
    },
    iptNumeroEmpresa: {
      alphaNum,
      requiredIf(value, self) {
        if (!self.showEmpresaForm) return true;
        return !!value;
      },
      maxLength: maxLength(12),
    },
    iptComplementoEmpresa: {
      maxLength: maxLength(32),
    },
    iptBairroEmpresa: {
      maxLength: maxLength(64),
    },
    iptCidadeEmpresa: {
      requiredIf(value, self) {
        if (!self.showEmpresaForm) return true;
        return !!value;
      },
      maxLength: maxLength(64),
    },
    slEstadoEmpresa: {
      requiredIf(value, self) {
        if (!self.showEmpresaForm) return true;
        return !!value;
      },
      maxLength: maxLength(2),
    },
  },
};
</script>


<style lang="stylus" scoped>
.address__container {
  margin-top: 42px;
}
</style>
